import { render, staticRenderFns } from "./WhatsAppCta.vue?vue&type=template&id=4e2cda70&scoped=true"
import script from "./WhatsAppCta.vue?vue&type=script&lang=js"
export * from "./WhatsAppCta.vue?vue&type=script&lang=js"
import style0 from "./WhatsAppCta.vue?vue&type=style&index=0&id=4e2cda70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e2cda70",
  null
  
)

export default component.exports